
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Card } from "@/components/ui/card";

const FAQs = () => {
  const faqs = [
    {
      question: "What is Dynamico?",
      answer: "Dynamico is a cutting-edge no-code platform designed for field workflow automation. It helps organizations digitize their inspection, audit, and maintenance processes without requiring any coding knowledge."
    },
    {
      question: "How easy is it to create forms in Dynamico?",
      answer: "Creating forms in Dynamico is incredibly simple with our drag-and-drop interface. You can build complex forms, checklists, and inspection templates within minutes, no technical expertise required."
    },
    {
      question: "Can I use Dynamico on mobile devices?",
      answer: "Yes! Dynamico is fully responsive and works seamlessly on all devices including iPhones, iPads, and Android devices. Our mobile app ensures you can collect data even in offline environments."
    },
    {
      question: "What types of reports can I generate?",
      answer: "Dynamico offers customizable report templates that can be automatically generated from your collected data. You can create PDF reports, Excel spreadsheets, and real-time dashboards to analyze your data."
    },
    {
      question: "Is my data secure with Dynamico?",
      answer: "Absolutely. We implement enterprise-grade security measures including encryption, secure data centers, and regular security audits to ensure your data is protected at all times."
    },
    {
      question: "Can I integrate Dynamico with other systems?",
      answer: "Yes, Dynamico offers robust API integration capabilities. You can connect with your existing systems including CRM, ERP, and other business applications."
    },
    {
      question: "What kind of support do you offer?",
      answer: "We provide comprehensive support including 24/7 technical assistance, dedicated account managers, regular training sessions, and extensive documentation to ensure your success."
    },
    {
      question: "How long does it take to implement Dynamico?",
      answer: "Implementation time varies based on your requirements, but most organizations can get started within days. Our team provides guided onboarding to ensure a smooth transition."
    },
    {
      question: "Can I customize workflows based on my business rules?",
      answer: "Yes, Dynamico allows you to create custom workflows with conditional logic, automated notifications, and approval processes tailored to your specific business requirements."
    },
    {
      question: "What industries does Dynamico serve?",
      answer: "Dynamico serves various industries including construction, manufacturing, healthcare, energy, and more. Our platform is flexible enough to adapt to any industry's specific needs."
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative h-[300px] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1522071820081-009f0129c71c"
          alt="FAQs Hero"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
            Frequently Asked Questions
          </h1>
        </div>
      </div>

      {/* FAQs Section */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Card className="p-8 bg-white shadow-lg">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-lg font-semibold text-gray-900">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-700">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Card>
      </div>
    </div>
  );
};

export default FAQs;
